var t={props:{renderSlot:{type:Function,default:function(t){return this.$parent.$scopedSlots.default(t)}},slotProps:{type:Object,default:function(){return{}}}},render:function(){return this.renderSlot(this.slotProps)}};export default t;
